import * as types from '../mutation-types'
import { getSuggestRequestParamsByService } from '@/utils/order'
import { DELIVERY_TYPE } from '@/mixins/constants'
import {
  suggestService
  // estimatedFee,
} from '@/store/api/order'

// truck-order-form can use all state of order-form module
const state = {
  path: [],
  package_detail: [],
  allowed_vehicles: [],
  suggestServices: [],
  loadingSuggestServices: false,
  suggestServicesError: null,
  shouldSuggestServices: true,
  orderTruckService: null,
  selectTruckService: false
}

// import {
//   COOKIE_NAME__SELECTED_SERVICE_ID
// } from "@/mixins/constants";

// import {
//   getCookie,
// } from "@/plugins/util";

const getters = {
  allowedVehicles: (state) => state.allowed_vehicles,
  suggestServices: (state) => state.suggestServices,
  loadingSuggestServices: (state) => state.loadingSuggestServices,
  orderTruckService: (state) => state.orderTruckService,
  suggestServicesError: (state) => state.suggestServicesError
}

const actions = {
  selectTruckService({ commit }) {
    commit(types.SET_TRUCK_SERVICE, true)
  },
  unSelectTruckService({ commit }) {
    commit(types.SET_TRUCK_SERVICE, false)
  },
  setOrderItemDescription({ commit }, params) {
    commit(types.UPDATE_ITEM_DESCRIPTION_TRUCK, params)
  },
  setAllowedVehicles({ commit }, data) {
    commit(types.SET_ALLOWED_VEHICLES, data)
  },
  async getSuggestServices({ commit, rootState, rootGetters }) {
    var params = {}
    var _services = []

    const services = rootState.serviceTypes.service_types
    services.forEach((service) => {
      const pr = getSuggestRequestParamsByService(state, service, {
        userProfile: rootGetters.userProfile,
        forEstimateFee: true,
        usePaymentMethodCash: true
      })

      // Estimate fee all services not support nationwide
      // TODO support nationwide
      if (
        service.delivery_type !== DELIVERY_TYPE.NATIONWIDE &&
        service.delivery_type === DELIVERY_TYPE.TRUCK
      ) {
        _services.push({
          _id: service._id,
          requests: pr.requests
        })
      }

      // if (service._id === state.service._id) {
      params = pr
      // }
    })

    if (_services.length > 0) {
      delete params.service_id
      delete params.requests
      delete params.allowed_vehicles
      params.order_time = rootGetters.orderFormDataV2.order_time
      params.idle_until = rootGetters.orderFormDataV2.order_time
      params.services = _services
      params.path = rootGetters.orderFormPath
      params.lang = rootGetters.locale
      params.package_detail = rootState.orderForm.package_detail

      commit(types.UPDATE_SHOULD_SUGGEST_SERVICE_ALL_SERVICES, false)
      commit(types.SET_LOADING_SUGGEST_SERVICES, true)

      try {
        commit(types.SET_LOADING_SUGGEST_SERVICES, true)
        const data = await suggestService(params)
        if (data) {
          commit(types.SET_ORDER_FORM_SUGGEST_SERVICE_ALL_SERVICES, {
            data
          })
        }
      } catch (error) {
        commit(types.SET_ORDER_FORM_SUGGEST_SERVICE_ALL_SERVICES, {
          error
        })
      } finally {
        commit(types.SET_LOADING_SUGGEST_SERVICES, false)
      }
    }
  },
  setOrderTruckService({ commit }, value) {
    commit(types.SET_ORDER_DEFAULT_TRUCK_SERVICE, value)
  }
}

const mutations = {
  [types.SET_TRUCK_SERVICE](state, data) {
    state.isTruck = data
  },
  [types.UPDATE_ITEM_DESCRIPTION_TRUCK](state, value) {
    if (state.path.length > 0) {
      state.package_detail = Array.isArray(value) ? value : [value]
    }
  },
  [types.RESET_TRUCK_FORM](state) {
    state.package_detail = []
  },
  [types.SET_ALLOWED_VEHICLES](state, data) {
    state.allowed_vehicles = data
  },
  [types.SET_ORDER_FORM_PATH](state, data) {
    state.path = data
    state.setPathLogTime = new Date().getTime()
  },

  [types.SET_ORDER_FORM_SUGGEST_SERVICE_ALL_SERVICES](state, { data, error }) {
    if (data) {
      state.suggestServices = data.data
    } else {
      state.suggestServicesError = error
    }
    state.estimatingFeeAllServices = false
  },
  [types.UPDATE_SHOULD_SUGGEST_SERVICE_ALL_SERVICES](state, value) {
    state.shouldSuggestServices = value
  },
  [types.SET_LOADING_SUGGEST_SERVICES](state, value) {
    state.loadingSuggestServices = value
  },
  [types.SET_ORDER_DEFAULT_TRUCK_SERVICE](state, data) {
    state.orderTruckService = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
